import React from "react"
import { debounce } from "lodash"
import { connect } from "react-redux"
import Cookies from "js-cookie"
import { push } from "connected-react-router"

import "./AskRoomNumber.less"

// 请收入房间号码

class AskRoomNumber extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { 
      number: Cookies.get("tepaRoom") || "", 
      height: window.innerHeight 
    }
    this.debouncedHeight = debounce(() => { this.update() }, 100, { trailing: true })
  }
  
  update() {
    this.setState({ height: window.innerHeight })
  }
  
  componentDidMount() {
    // #WARNING this logic was duped from CoolPageJSX
    window.addEventListener("resize", this.debouncedHeight, false)
  }
  
  componentWillUnmount() {
    window.removeEventListener("resize", this.debouncedHeight, false)
  }
  
  set() {
    const n = parseInt(this.state.number)
    Cookies.set("tepaRoom", n, { expires: 10 })
    this.props.gotoHome()
  }
  
  render() {
    return (
      <div className="askRoom" style={{ height: this.state.height }}>
        <div className="container">
          <header>
            <h1>
              NH Collection Madrid
              <br />
              Palacio de Tepa
            </h1>
            <h1>欢迎来到NH酒店</h1>
          </header>
          <div>
            <p>请收入房间号码</p>
            <input 
              type="number" 
              value={this.state.number} 
              onChange={evt => {
                const n = parseInt(evt.target.value)
                if (!evt.target.value || (n > 0 && n < 100)) {
                  this.setState({ number: evt.target.value })
                }
              }}
            />
          </div>
          <button disabled={!this.state.number} onClick={() => this.set()}>下一步</button>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (_state, _ownProps) => ({ })

const mapDispatchToProps = dispatch => {
  const goto = url => dispatch(push(url))
  return {
    goto,
    gotoHome: () => goto(`/catalogo/tepa`),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AskRoomNumber)



// WEBPACK FOOTER //
// ./src/app/catalogo/hotels/AskRoomNumber.jsx